export default class ScanService {
    constructor($q, httpRequest) {
        this.$q = $q
        this.httpRequest = httpRequest
    }

    getContractScanParam(param) {
        return this.httpRequest.post_getContractScanInitParam({
            host: window.location.origin,
            ...param,
        })
    }

    getSupplementParam(param) {
        return this.httpRequest.post_getScanInitParam({
            host: window.location.origin,
            ...param,
        })
    }

    doScan(param, initParam) {
        const { httpRequest } = this
        const deffered = this.$q.defer()
        const hostUrl = 'http://127.0.0.1:'
        $.jsonp({
            url: `${hostUrl + initParam.data.value.port}/ScanFP`,
            data: {
                SID: initParam.data.value.SID,
                SIDParam: initParam.data.value.SIDParam,
                Config: initParam.data.value.Config,
            },
            charset: 'GBK',
            callbackParameter: 'callback',
            timeout: 86400000,
            success(json) {
                if (json.retcode === '1') {
                    httpRequest.post_scanEndCallBack({
                        responseBody: json.ResponseStr,
                        scanType: param.scanType,
                    }).then((scanResult) => {
                        deffered.resolve(scanResult.data.value)
                    }, (error) => {
                        deffered.reject(error.data.message)
                    })
                }
            },
            error() {
                deffered.reject('扫描服务调用失败')
            },
        })
        return deffered.promise
    }

    scan(param) {
        return this.getContractScanParam(param).then((res) => this.doScan(param, res))
    }

    supplement(param) {
        return this.getSupplementParam(param).then((res) => this.doScan(param, res))
    }
}
ScanService.$inject = ['$q', 'httpRequest']



// WEBPACK FOOTER //
// ./src/common/services/scanService.js